/**
 * Gli scatti della guida, importati uno per uno.
 *
 * Passano da Vite e non da una cartella `public/`, ed è la scelta che tiene
 * insieme le due applicazioni: il banco è servito sotto `/` e l'ufficio sotto
 * `/backoffice/`, ma in sviluppo sono due server distinti su due porte. Un
 * indirizzo scritto a mano funzionerebbe di qua e non di là — o dietro nginx e
 * non in sviluppo, che è il modo peggiore di sbagliare. Vite conosce già `base`
 * e già l'origine di sviluppo.
 *
 * Esplicito e non `import.meta.glob`: un elenco scritto è ciò che il test
 * confronta con `figureFiles('banco')`. Una figura citata nel testo e mai
 * importata è un rettangolo vuoto che nessun tipo vede.
 *
 * Il banco importa **solo le sue**: le pagine d'ufficio qui non si aprono, e i
 * loro scatti sarebbero peso scaricato per niente.
 */

import banco_ricezione from '@errebi/guide/screenshots/banco-ricezione.png';
import banco_scorta from '@errebi/guide/screenshots/banco-scorta.png';
import banco_express_bolla from '@errebi/guide/screenshots/banco-express-bolla.png';
import banco_prelievi from '@errebi/guide/screenshots/banco-prelievi.png';

/** Nome del file → indirizzo che Vite gli assegna. */
export const FIGURE: Readonly<Record<string, string>> = {
  'banco-ricezione.png': banco_ricezione,
  'banco-scorta.png': banco_scorta,
  'banco-express-bolla.png': banco_express_bolla,
  'banco-prelievi.png': banco_prelievi,
};
